module.exports = __webpack_public_path__ + "assets/img/3c7f169a4f155e9a4a301838c7d8adc2.png";